import React from 'react';
import BookingDetails from './BookingDetails';

const CalendarModal = ({ 
  booking, 
  onClose, 
  actionLoading, 
  onEditDates, 
  onCancel, 
  onAccept,
  currentUserId 
}) => {
  return (
    <div className='calendar-modal'>
      <BookingDetails
        booking={booking}
        actionLoading={actionLoading}
        onEditDates={onEditDates}
        onCancel={onCancel}
        onAccept={onAccept}
        currentUserId={currentUserId}
        showCloseButton={true}
        onClose={onClose}
      />
    </div>
  );
};

export default CalendarModal;
